export function DemandStaffingGrid() {
	return <div>Demand Staffing Grid</div>;
}

export default DemandStaffingGrid;
